<template>
  <div class="user-card">
    <YorkbbsImage
      class="user-avatar"
      :src="avatar | webpFormat(100)"
      :link="homeURL"
      target="_blank"
      v-if="avatar"
    ></YorkbbsImage>
    <i class="user-avatar__icon yk-house_user" v-else></i>
    <div class="user-name e">{{ username }}</div>
    <div class="user-wallet">
      <a class="user-wallet__left" target="_blank" :href="`/wallet` | hostBuild('home')">
        <img :src="require('./images/icon_coin.png')" />
        <span class="user-wallet__num">{{ balance | moneyFormat }}</span>
      </a>
      <a class="user-wallet__right" target="_blank" :href="`/wallet` | hostBuild('home')">充值</a>
    </div>
    <ul class="user-nav__list">
      <li class="user-nav__item">
        <a class="user-nav__box" :href="homeURL" target="_blank" title="个人中心">
          <i class="yk-house_user"></i>
          <span class="user-nav__name">个人中心</span>
        </a>
      </li>
      <li class="user-nav__item">
        <a class="user-nav__box" :href="'/center/post' | hostBuild('home')" target="_blank" title="我的帖子">
          <i class="yk-bank_order"></i>
          <span class="user-nav__name">我的帖子</span>
        </a>
      </li>
      <li class="user-nav__item">
        <a class="user-nav__box" :href="'/center/collect' | hostBuild('home')" target="_blank" title="我的收藏">
          <i class="yk-home_collection"></i>
          <span class="user-nav__name">我的收藏</span>
        </a>
      </li>
      <li class="user-nav__item">
        <a class="user-nav__box" :href="'/center/information' | hostBuild('home')" target="_blank" title="我的发布">
          <i class="yk-home_release"></i>
          <span class="user-nav__name">我的发布</span>
        </a>
      </li>
      <li class="user-nav__item">
        <a class="user-nav__box" :href="'/center/account' | hostBuild('home')" target="_blank" title="账户设置">
          <i class="yk-bank_setting"></i>
          <span class="user-nav__name">账户设置</span>
        </a>
      </li>
    </ul>
    <ul class="user-other__list">
      <li class="user-other__item" title="退出">
        <button class="user-other__box" @click="$emit('logout')">
          <i class="yk-tuichu"></i>
          <span class="user-nav__name">退出</span>
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
import { hostBuild } from '@/utils/utils';
export default {
  name: 'CardUser',
  props: {
    // 余额，分
    balance: Number,
    // 关注数
    myAttentionCount: Number,
    // 粉丝数
    myFansCount: Number,
    // 积分
    oldIntegral: Number,
  },
  computed: {
    // 用户头像
    avatar() {
      return this.$store.getters.user.avatar;
    },
    // 用户ID
    userId() {
      return this.$store.getters.user.id;
    },
    // 用户名
    username() {
      return this.$store.getters.user.username;
    },
    // 用户主页
    homeURL() {
      return hostBuild('/', 'home');
    },
  },
};
</script>
<style lang="scss" scoped>
.user-card {
  width: 230px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  position: absolute;
  left: -100px;
  z-index: 10;
}
.user-avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -35px;
}
.user-avatar__icon {
  box-sizing: border-box;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 1px solid #cccccc;
  font-size: 30px;
  background: #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -35px;
}
.user-name {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #222;
  padding: 45px 15px 20px;
  border-bottom: 1px solid #f4f4f4;
}
.user-wallet {
  padding: 0 20px;
  height: 60px;
  border-bottom: 1px solid #f4f4f4;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.user-wallet__left {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
  }
}
.user-wallet__num {
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
  margin-left: 10px;
}

.user-nav__list {
  padding: 14px 0;
  border-bottom: 1px solid #f4f4f4;
}
.user-nav__item {
  &:hover {
    background-color: #f4f4f4;
  }
}
.user-nav__box {
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 36px;

  i {
    font-size: 18px;
  }
}
.user-nav__name {
  font-size: 14px;
  line-height: 20px;
  margin-left: 20px;
}
.user-other__list {
  padding: 14px 0;
}
.user-other__item {
  &:hover {
    background-color: #f4f4f4;
  }
}
.user-other__box {
  padding: 0 20px;
  height: 36px;
  display: flex;
  align-items: center;
  i {
    font-size: 18px;
  }
}

.user-wallet__right {
  font-size: 14px;
  line-height: 20px;
  color: var(--primary-color);
  text-decoration: underline;
}
</style>
